import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { firstValueFrom, map, Observable } from 'rxjs';

import { Store } from '@ngrx/store';

import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';
import { setShowChannelsFilters } from '../../shared/store/ui.actions';
import { WorkspaceFeatures, WorkspaceModule, WORKSPACES, WorkspaceShorter } from '../interfaces/IWorkspace';
import { loadWorkspaces, selectWorkspace } from '../store/chat.actions';
import { AppStateWithChat } from '../store/chat.reducer';

@Injectable()
export class WorkspacesService {
  constructor(private store: Store<AppStateWithChat>, public http: HttpClient, private env: MessagingEnvironmentService) {
    this.loadWorkspaces();
  }

  selectWorkspace(workspace: WorkspaceShorter): void {
    if (workspace) {
      const fullWorkspace = WORKSPACES.find((e) => e.shortVersion === workspace);
      if (fullWorkspace) {
        this.store.dispatch(setShowChannelsFilters({ value: fullWorkspace.hasFiltersOpenByDefault }));
        this.store.dispatch(
          selectWorkspace({
            selectedWorkspace: fullWorkspace,
          })
        );
      }
    }
  }

  loadWorkspaces() {
    this.store.dispatch(
      loadWorkspaces({
        workspaces: WORKSPACES.filter((workspace) =>
          workspace.features.some((feature) => feature === WorkspaceFeatures.canDisplayInWorkspacesColumn)
        ),
      })
    );
  }

  async findAndSetWorkspace(data: { subAccountUID: string; accountUID: string; accountPhone: string }): Promise<void> {
    if (data.subAccountUID && data.accountUID && data.accountPhone) {
      const workspaceModule = await firstValueFrom(
        this.getWorkspaceByNumber({
          subAccountUID: data.subAccountUID,
          phoneNumber: data.accountPhone,
          accountUID: data.accountUID,
        })
      );
      if (!workspaceModule) {
        return;
      }
      const workspace = WORKSPACES.find((e) => e.id.toUpperCase() === (workspaceModule.toUpperCase() as WorkspaceModule));
      if (workspace) {
        this.selectWorkspace(workspace.shortVersion);
      }
    }
  }

  getWorkspaceByNumber(data: {
    phoneNumber: string;
    accountUID: string;
    subAccountUID: string;
  }): Observable<WorkspaceModule> {
    const encodedPhoneNumber = encodeURIComponent(data.phoneNumber);
    return this.http
      .get<{ module: WorkspaceModule }>(
        `${this.env.env.apiUrl + this.env.env.messagingApiPath}/phone/assignment?accountUID=${
          data.accountUID
        }&subAccountUID=${data.subAccountUID}&phoneNumber=${encodedPhoneNumber}`
      )
      .pipe(
        map((res) => {
          return res.module;
        })
      );
  }

  /** @deprecated Use {@link getWorkspaceByNumber} instead */
  getWorskpaceByNumber(data: {
    phoneNumber: string;
    accountUID: string;
    subAccountUID: string;
  }): Observable<WorkspaceModule> {
    return this.getWorkspaceByNumber(data);
  }
}
